/**
 * DiamondAnimation — diamond emoji with a rotating sparkle ring + shine sweep.
 * Prism-like glow radiates outward while 6 sparkle points orbit the emoji.
 */
export default function DiamondAnimation({ size = 140 }) {
  const sparkles = new Array(6).fill(0).map((_, i) => ({
    angle: (i * 360) / 6,
    delay: `${i * 0.08}s`,
  }));
  return (
    <div
      className="pointer-events-none"
      style={{ width: size, height: size, position: "relative" }}
    >
      <style>{`
        @keyframes diamond-pulse {
          0%   { transform: scale(0.4) rotate(-20deg); opacity: 0; filter: drop-shadow(0 0 0 rgba(96,165,250,0)); }
          25%  { transform: scale(1.6) rotate(10deg);  opacity: 1; filter: drop-shadow(0 0 44px rgba(96,165,250,0.95)); }
          60%  { transform: scale(1.3) rotate(-4deg);  opacity: 1; filter: drop-shadow(0 0 32px rgba(167,139,250,0.9)); }
          100% { transform: scale(1) rotate(0deg);     opacity: 0; filter: drop-shadow(0 0 0 rgba(96,165,250,0)); }
        }
        @keyframes diamond-orbit {
          0%   { transform: rotate(0deg) translateX(var(--r, 46px)) rotate(0deg) scale(0.3); opacity: 0; }
          15%  { opacity: 1; }
          85%  { opacity: 1; }
          100% { transform: rotate(360deg) translateX(var(--r, 46px)) rotate(-360deg) scale(0.6); opacity: 0; }
        }
        @keyframes diamond-shine {
          0%   { transform: translateX(-100%) skewX(-25deg); opacity: 0; }
          40%  { opacity: 0.6; }
          100% { transform: translateX(220%) skewX(-25deg); opacity: 0; }
        }
      `}</style>
      {/* Radial prism glow */}
      <div
        style={{
          position: "absolute",
          inset: "20%",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(147,197,253,0.5), rgba(167,139,250,0.3), transparent 70%)",
          animation: "diamond-pulse 1.4s ease-out forwards",
        }}
      />
      {/* Sparkle orbit */}
      {sparkles.map((s, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: 10,
            height: 10,
            transform: `translate(-50%, -50%) rotate(${s.angle}deg) translateX(46px)`,
            animation: `diamond-orbit 1.4s ease-out ${s.delay} forwards`,
            "--r": "46px",
          }}
        >
          <div
            style={{
              width: 10,
              height: 10,
              background: "linear-gradient(45deg, #dbeafe, #c4b5fd)",
              transform: "rotate(45deg)",
              boxShadow: "0 0 12px #93c5fd",
            }}
          />
        </div>
      ))}
      {/* Diamond emoji */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          fontSize: size * 0.7,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: "diamond-pulse 1.4s ease-out forwards",
        }}
      >
        💎
      </div>
      {/* Shine sweep */}
      <div
        style={{
          position: "absolute",
          top: "40%",
          left: 0,
          width: "40%",
          height: "20%",
          background:
            "linear-gradient(90deg, transparent, rgba(255,255,255,0.7), transparent)",
          animation: "diamond-shine 1.4s ease-out 0.3s forwards",
        }}
      />
    </div>
  );
}
